import React from 'react';

const Home = React.lazy(() => import('./views/Home'));
const Los = React.lazy(() => import('./views/Los'));
const LosNumber = React.lazy(() => import('./views/Los/Number'));
const LosManuscript = React.lazy(() => import('./views/Los/Manuscript'));
const About = React.lazy(() => import('./views/About'));
const Aims = React.lazy(() => import('./views/Aims'));
const News = React.lazy(() => import('./views/News'))
const Publication = React.lazy(() => import('./views/Publication'));
const Editorial = React.lazy(() => import('./views/Editorial'));
const PeerReviewProcess = React.lazy(() => import('./views/PeerReviewProcess'));
const Contact = React.lazy(() => import('./views/Contact'));
const GuideForAuthor = React.lazy(() => import('./views/GuideForAuthor'));
const Search = React.lazy(() => import('./views/Search'));
const AdvanceSearch = React.lazy(() => import('./views/AdvanceSearch'));
const OnlineFirst = React.lazy(() => import('./views/OnlineFirst'));
// const AdminLos = React.lazy(() => import('./views/Admin/Home/ListOfIssue'));

const routes = [
    // { path: '/home/list_of_issue', name: 'LIST OF ISSUE', component: AdminLos },
    { path: '/home', name:'HOME', component: Home},
    { path: '/los/number', name:'HOME', component: LosNumber},
    { path: '/los/manuscript', name:'HOME', component: LosManuscript},
    { path: '/los', name:'HOME', component: Los},
    { path: '/about', name:'HOME', component: About},
    { path: '/aims', name:'HOME', component: Aims},
    { path: '/news', name:'NEWS', component: News},
    { path: '/publication', name:'HOME', component: Publication},
    { path: '/editorial', name:'HOME', component: Editorial},
    { path: '/peer-review-process', name:'HOME', component: PeerReviewProcess},
    { path: '/contact', name:'HOME', component: Contact},
    { path: '/guideforauthor', name:'HOME', component: GuideForAuthor},
    { path: '/search', name:'HOME', component: Search},
    { path: '/advance-search', name:'HOME', component: AdvanceSearch},
    { path: '/online-first', name:'HOME', component: OnlineFirst},

    

]
export default routes;